import React from 'react'

import Logo from '../images/tkt-logo.png'
import CustomerService from '../images/customer-service.png'
import { Link } from 'gatsby'

const Header = () => {
  return (
    <nav className='navbar bg-light navbar_padding' role='navigation'>
      <div className='container-fluid form_main'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-3 col-xs-4 form_main'>
              <Link to='/'>
                <img src={Logo} alt='' />
              </Link>
            </div>
            <div className='col-md-9 col-xs-8'>
              <div className='sa-call-blk'>
                <div className='sa-24-blk'>
                  <a href='tel:1-213-225-9813'>
                    <span className='sa-call-txt'>Call 24x7</span>
                    <div className='sa-free-mob'>It's Free!</div>
                  </a>
                </div>
                <div className='sa-assist-img-header'>
                  <img src={CustomerService} alt='' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Header
